import React from 'react';
import { Container, Accordion } from "react-bootstrap";

const FAQ = () => {

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Where can I find the best hearing aid centre in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Sound for Life (SFL) has multiple hearing aid centres in Patna. They offer professional audiologist consultations and hearing aid trials."
                }
            },
            {
                "@type": "Question",
                "name": "Does SFL Hearing Solutions offer a hearing aid trial in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, SFL Hearing Solutions offers a hearing aid trial for the latest digital hearing aids. Patients can experience the device at the clinic or during a home visit before purchasing."
                }
            },
             {
                "@type": "Question",
                "name": "What is the price of hearing aids in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Hearing aid prices in Patna vary based on technology and features. At SFL, we provide options ranging from basic digital models to premium AI-enabled devices. We also offer 0% EMI schemes and up to 4 years of warranty to make hearing solutions affordable."
                }
            },
             {
                "@type": "Question",
                "name": "Can I get a home visit for a hearing test in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, Sound for Life provides professional home visit services across Patna. Our audiologists bring diagnostic equipment and trial devices to your doorstep, which is ideal for senior citizens or those with mobility issues."
                }
            },
            {
                "@type": "Question",
                "name": "Can I get a home visit for a hearing test in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, Sound for Life provides home visit services across Patna for hearing tests and hearing aid trials, specifically designed for senior citizens and those with limited mobility."
                }
            }
        ]
    };

    return (
        <>
            {/* FAQ Schema */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
            />

            <Container className="text-center">
                <h2 className="text-center h1">
                    <span className="text-orange h3">FAQs:</span>
                </h2>

                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Where can I find the best hearing aid centre in Patna?</Accordion.Header>
                        <Accordion.Body>
                            Sound for Life (SFL) has multiple hearing aid centres in Patna. We provide hearing aid trials, diagnostic tests by certified audiologists, and a wide range of global brands like Signia, Phonak, and Widex.
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Does SFL Hearing Solutions offer a hearing aid trial in Patna?</Accordion.Header>
                        <Accordion.Body>
                            Yes, we offer a "Try Before You Buy" policy. You can visit any of our Patna clinics or request a home visit to test the latest digital and invisible hearing aids in your own environment before making a purchase.
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header>What is the price of hearing aids in Patna?</Accordion.Header>
                        <Accordion.Body>
                            Hearing aid prices in Patna vary based on technology and features. At SFL, we provide options ranging from basic digital models to premium AI-enabled devices. We also offer 0% EMI schemes and up to 4 years of warranty to make hearing solutions affordable.
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Can I get a home visit for a hearing test in Patna?</Accordion.Header>
                        <Accordion.Body>
                            Yes, Sound for Life provides professional home visit services across Patna. Our audiologists bring diagnostic equipment and trial devices to your doorstep, which is ideal for senior citizens or those with mobility issues.
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Which brands of hearing aids are available at SFL Patna?</Accordion.Header>
                        <Accordion.Body>
                            We are authorized partners for leading global hearing aid brands, including Signia (formerly Siemens), Phonak, Widex, Resound, and Oticon. We ensure genuine products with official manufacturer warranties.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>
        </>
    );
};

export default FAQ;
